import { Component } from '@angular/core';
import { MenuItemComponent } from "./menu-item/menu-item.component";
import { CommonModule } from '@angular/common';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { MenuService } from 'src/app/services/menu/menu.service';
import { FormsModule } from '@angular/forms';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { LanguageService } from 'src/app/services/language/language.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorComponent } from "../../layout/error/error.component";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MenuModalComponent } from './menu-modal/menu-modal.component';
import { AdminService } from 'src/app/services/admin/admin.service';





@Component({
  selector: 'app-menu-manager',
  imports: [MenuItemComponent, CommonModule, DragDropModule, FormsModule, SpinnerComponent, ErrorComponent],
  templateUrl: './menu-manager.component.html',
  styleUrl: './menu-manager.component.css'
})
export class MenuManagerComponent {

  // currently displayed items (depends on selectedSection)
  menuItems: any[] = [];

  // raw menus from API: { main, top, hidden, service, other }
  allMenus: Record<string, any[]> = {};

  // select value (default must be main)
  selectedSection: 'main' | 'top' | 'hidden' | 'buttom' | 'other' = 'main';

  // options for <select>
  menuSections = [
    { value: 'main', label: 'მთავარი მენიუ' },
    { value: 'top', label: 'ზედა მენიუ' },
    { value: 'hidden', label: 'დამალული' },
    { value: 'buttom', label: 'ქვედა მენიუ' },
  ] as const;

  load = false;
  loadSave = false;

  error = false;

  isDrangDrop = false;

  currentLang = 'geo';

  constructor(
    private MenuService: MenuService, 
    private langService: LanguageService,
    private ToastrService: ToastrService,
    private modalService: NgbModal,
    public admin: AdminService
  ){

    this.currentLang = this.langService.getLanguage();

    this.langService.currentLanguage$.subscribe((lang) => {
      this.currentLang = lang;
        this.getMenu()
    });

    this.getMenu()

  }

  getMenu(){
    this.load = true
    this.MenuService.getMenu().subscribe(
      (res: any) => {
        console.log(res)
        this.load = false
        this.allMenus = res.data;

        console.log('all menu: ',this.allMenus)
        this.applySection();
        // console.log(this.menuItems)
        this.error = false
      },
      (error: any) => {
        this.error = true
        this.load = false
      }
    );
  }

  private applySection() {
    const section = this.selectedSection || 'main';
    const data = this.allMenus?.[section];

    // IMPORTANT:
    // Use a new array reference so Angular updates the view immediately
    // after we mutate the tree in-memory (move parent, insert/remove, etc.)
    this.menuItems = Array.isArray(data) ? [...data] : [];
  }

  onMenuChange(section?: string) {
    // allow (change) event to pass the selected value, but also works without args
    if (section) this.selectedSection = section as any;
    this.applySection();
    this.isDrangDrop = false;
  }

  getPayload(items: any[]): any[] {
    return items.map(item => ({
      id: item.id,
      sort: item.sort,
      children: item.children?.length ? this.getPayload(item.children) : []
    }));
  }


  save() {
    this.loadSave = true;

  // Prepare payload for main items and their children
  // const payload = this.menuItems.map((item: any, index: number) => ({
  //   id: item.id,
  //   sort: index + 1,
  //   children: item.children?.map((child: any, childIndex: number) => ({
  //     id: child.id,
  //     sort: childIndex + 1
  //   })) || []
  // }));
    const payload = this.getPayload(this.menuItems);


    this.MenuService.updateSort(payload).subscribe(
      () => {
        this.loadSave = false;
        this.ToastrService.success('შენახულია!');
        this.isDrangDrop = false;
        this.getMenu();
      },
      () => {
        this.loadSave = false;
        this.ToastrService.error('შეცდომა!');
      }
    );
  }

  prepareItem(item: any, index: number) {
    return {
      id: item.id,
      order: index,
      menutitle: item.title,
      visibility: item.visibility ? 1 : 0,
      children: item.children?.map((child: any, childIndex: number) => ({
        id: child.id,
        order: childIndex,
        title: child.title,
        visibility: child.visibility ? 1 : 0,
      })) || [],
    };
  }

  drop(event: CdkDragDrop<any[]>) {
    // console.log('From:', event.previousIndex, 'To:', event.currentIndex);
    // console.log('Before:', JSON.parse(JSON.stringify(this.menuItems)));
    moveItemInArray(this.menuItems, event.previousIndex, event.currentIndex);
    this.menuItems.forEach((item: any, index: number) => {
      item.order = index;
    });
    this.menuItems.sort((a: any, b: any) => a.order - b.order);
    // console.log('After:', this.menuItems);
    this.isDrangDrop = true
  }

    trackById(index: number, item: any): number {
      return item.id;
    }

  onUpdate(evt?: any) {
    // Simpler + reliable: reload whole menu after any update from modal / child component
    // (avoids complex in-memory tree moves)
    this.getMenu();
  }

  openAddModal() {
    const modalRef = this.modalService.open(MenuModalComponent, { size: 'lg' });
    // New item defaults (match modal form fields)
    modalRef.componentInstance.menuItem = {
      id: null,
      title: '',
      menutitle: '',
      visible: 1,
      visibility: 1,
      up_id: 0,
      parent_id: 0,
      pos: 2, // default main
      status: 1,
      show_menu: 0,
      visible_sub_menu: 0,
      redirect: null,
      redirect_target: 0,
      children: []
    };
    modalRef.componentInstance.allMenu = this.allMenus;
    modalRef.result
      .then((createdItem: any) => {
        if (!createdItem) return;
        // After creating a new item, reload full menu so UI always matches DB
        this.getMenu();
      })
      .catch(() => {});
  }

  

}
